import Form_9 from './Form_9-redux';

export default Form_9;
